/**
 * Peggell search modal helpers — suggestion chips as search terms.
 */
(function () {
  function applySuggestion(root, term) {
    if (!root || !term) return;

    const input = root.querySelector('input[type="search"]');
    if (!input) return;

    input.value = term;
    input.focus();
    input.dispatchEvent(new Event('input', { bubbles: true }));

    const resetButton = root.querySelector('button[type="reset"]');
    if (resetButton) {
      resetButton.classList.toggle('hidden', term.length === 0);
    }

    // When predictive search is disabled, submit like a normal search term.
    if (root.tagName !== 'PREDICTIVE-SEARCH' && input.form) {
      input.form.submit();
    }
  }

  function bindSuggestions(scope) {
    scope.querySelectorAll('[data-search-suggestion]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const term = (button.getAttribute('data-search-term') || '').trim();
        const root =
          button.closest('predictive-search') ||
          button.closest('search-form') ||
          button.closest('.peggell-search__predictive');
        applySuggestion(root, term);
      });
    });
  }

  function init() {
    document.querySelectorAll('.peggell-search').forEach(bindSuggestions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
